import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import {
  provideHttpClient,
  withInterceptors,
  HttpClient,
} from "@angular/common/http";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { pendingWorkProvider } from "./providers/pending-work-provider";
import { provideAuth } from "./providers/provide-auth";
import { authInterceptor } from "./interceptors/auth-interceptor.interceptor";
import { errorDialogInterceptor } from "./interceptors/error-dialog-interceptor.interceptor";
import { pendingWorkInterceptor } from "./interceptors/pending-work-interceptor.interceptor";

import { BusinessObjectBase } from "./business-objects/base";
import { registerSchemaFormFields } from "./schema-forms-registration";
import { routes } from "./app.routes";

// zone.js replaces the global Promise with ZoneAwarePromise, which implements the
// statics it knows about but not the ES2025 `Promise.try`. Dependencies that call it
// (pdf.js, for one) fail with "Promise.try is not a function" in every zoned app, no
// matter how modern the browser. Remove once zone.js implements `try` upstream.
const zonedPromise = Promise as any;
if (typeof zonedPromise.try !== "function") {
  zonedPromise.try = (fn: (...args: any[]) => any, ...args: any[]) =>
    new Promise((resolve) => resolve(fn(...args)));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorDialogInterceptor,
        pendingWorkInterceptor,
      ]),
    ),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: "outline",
        subscriptSizing: "dynamic",
        floatLabel: "always",
      },
    },
    pendingWorkProvider(),
    provideAuth(),
    provideAppInitializer(() => {
      BusinessObjectBase.configure(inject(HttpClient));
      registerSchemaFormFields();
    }),
  ],
};
